export function getFullName(
  firstName?: string | null,
  middleName?: string | null,
  lastName?: string | null
): string {
  return [firstName, middleName, lastName]
    .filter(
      (name): name is string =>
        typeof name === 'string' && name.trim().length > 0
    )
    .map((name) => name.trim())
    .join(' ');
}